import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { EmailProvenance, emailProvenanceLines } from "./emailProvenance";

/**
 * Where the stored address came from, when it was last verified and how the lead's last email went
 * (PREC-4262). Renders nothing when none of the three is known.
 */
export const EmailProvenanceLines: FunctionComponent<{ data: EmailProvenance }> = ({ data }) => {
	const { t } = useTranslation();
	const lines = emailProvenanceLines(data, t);

	if (!lines.length) {
		return null;
	}

	return (
		<div
			className="flex flex-col gap-0.5 px-2 pb-1 pt-1 text-[11.5px]"
			data-testid="email-provenance"
		>
			{lines.map((line) => (
				<div key={line.kind} className="flex gap-1">
					<span className="text-text-meta">{line.label}:</span>
					<span className={line.warning ? "text-status-error" : "text-gray-700"}>{line.value}</span>
				</div>
			))}
		</div>
	);
};
